export default class SortStoreItems {
  constructor() {
    this.contents = document.querySelector('._sort');
    this.sortOpener = this.contents.querySelector('._sortOpener');
    this.sortMenu = this.contents.querySelector('._sortMenu');
    this.select = this.contents.querySelector('._select');
    this.radios = this.contents.querySelectorAll("input[type=radio]");
    this.label = this.contents.getElementsByTagName("label");

    this.isOver = false;

    this.timer;

    this.setup()
  }

  setup () {
    this.sortMenu.addEventListener('focusin', (event) => {
      this.stopTimer();
    });
    this.sortMenu.addEventListener('focusout', (event) => {
      this.setTimer();
    });
    this.sortOpener.addEventListener('click', (event) => {
      this.sortMenu.classList.add("open");
      this.sortOpener.setAttribute('aria-expanded', 'true')
      setTimeout(function()
      {
        this.contents.focus();
      }.bind(this), 300);
    });
    document.addEventListener('mousedown', (event) => {
      if(!this.isOver)
      {
        // event.preventDefault();
        this.sortMenu.classList.remove("open");
        this.sortOpener.setAttribute('aria-expanded', 'false')
      }
    });
		for(var i = 0; i <  this.radios.length; i++)
    {
      this.radios[i].addEventListener('click', (event) => {
        let target = event.currentTarget;
        if(target.dataset.id) this.select.textContent = target.dataset.id;
      })
    }
		for(var i = 0; i <  this.label.length; i++)
    {
      this.label[i].addEventListener('mousedown', (event) => {
        this.isOver = true;
      });
      this.label[i].addEventListener('mouseup', (event) => {
        this.isOver = false;
      });
    }
  }

  setTimer () {

    clearTimeout(this.timer);
    this.timer = setTimeout(this.setTimerComplete.bind(this), 300);
  }
  stopTimer () {

    clearTimeout(this.timer);
  }
  setTimerComplete () {
    this.sortMenu.classList.remove("open");
    this.sortOpener.setAttribute('aria-expanded', 'false')
  }
}